<template>
	<div class="rowSectionForm">
		<ul class="rowSectionForm-params">
			<li>Нагрузка, кг: {{ data.capacity }}</li>
			<li class="racks-param" v-if="displayExpertRacksInfo">Стойки: Expert
				<Info>
					На данное кол-во ярусов необходимо применение стоек EXPERT
				</Info>
			</li>
		</ul>
		<div class="rowSectionForm-fieldset">
			<div class="rowSectionForm-field">
				<label>Ширина, мм</label>
				<Select v-model="width" :options="options.width"></Select>
			</div>
			<div class="rowSectionForm-field">
				<label>Кол-во ярусов</label>
				<Select v-model="count" :options="options.count"></Select>
			</div>
			<div class="rowSectionForm-field">
				<label>Тип полок</label>
				<Select v-model="shelvesType" :options="optionShelvesType"></Select>
			</div>
			<div class="rowSectionForm-field">
				<label>Тип балок</label>
				<div class="fieldWrap">
					<Select v-model="beamsType" :options="possibleBeamsTypes"></Select>
					<div class="beamsIconsWrap">
						<div class="beamsIcons">
							<InfoBeamsPopup />
							<Info v-if="isWideSection">
								Для выбранной ширины секции могут быть установлены только Z-балки
							</Info>
						</div>
					</div>
				</div>
			</div>
			<div class="rowSectionForm-field">
				<Checkbox
				:value="couplerValue"
				:disabled="couplerDisabled"
				@input="coupler = $event"
				>
					Стяжки
				</Checkbox>
				<Info v-if="couplerDisabled">
					Стяжки повышают прочность конструкции. Для секций шириной 2400 мм и 2700 мм с Z-балками установка стяжек обязательна
				</Info>
			</div>
			<button class="rowSectionForm-submit" @click="$emit('submit', $data)">Применить</button>
		</div>
	</div>
</template>

<script>
	import Info from './Info';
	import InfoBeamsPopup from './InfoBeamsPopup';
	import Select from './Select';
	import Checkbox from './Checkbox2';

	export default {
		name: 'RowSectionForm',
		inject: {
			options: 'options',
			getShelvesTypeOpts: 'getShelvesTypeOpts',
		},
		props: {
			data: Object,
		},
		data() {
			return {
				capacity: 300,
				height: 2000,
				depth: 400,
				width: 900,
				count: 3,
				shelvesType: 'Стандартные',
				beamsType: 'Z-балки',
				coupler: false,
				...this.data, // в т.ч. переписывают выше указанные значения
			};
		},
		components: {
			Info,
			InfoBeamsPopup,
			Select,
			Checkbox
		},
		computed: {
			displayExpertRacksInfo() {
				// return this.racksType && this.racksType === 'Expert'
				return this.count >= 6
			},
			optionShelvesType() {
				return this.getShelvesTypeOpts(+this.data.depth, +this.width, +this.count, +this.capacity) ;
			},
			isWideSection() {
				return this.width == 2400 || this.width == 2700;
			},
			couplerValue() {
				return this.isWideSection ? true : this.coupler;
			},
			couplerDisabled() {
				return this.isWideSection;
			},
			possibleBeamsTypes() {
				const possible = []
				this.options.beamsType.forEach(item => {
					if (this.isWideSection) {
						if (item == 'Z-балки') {
							possible.push(item)
						}
					} else {
						possible.push(item)
					}
				})

				return possible
			}
		},
		methods: {
			widthWatcher() {
				if (this.isWideSection) {
					if (this.beamsType != 'Z-балки') {
						this.beamsType = 'Z-балки'
						alert('Для выбранной ширины секции могут быть установлены только Z-балки')
					}
				}
			}
		},
		watch: {
			width: {
				handler: 'widthWatcher'
			}
		}
	}
</script>

<style scoped>
	.rowSectionForm {
		display: flex;
		flex-direction: column;
	}
	.rowSectionForm-submit {
		padding: 16px;
		width: 146px;
		max-width: 100%;
	}
	.rowSectionForm-params {
		margin: 0;
		padding: 0;
		list-style: none;
	}
	.rowSectionForm-params > li {
		margin-bottom: 8px;
	}
	.rowSectionForm-params > .racks-param {
		color: #cccccc;
	}
	.rowSectionForm-fieldset {
		margin: auto 0;
	}
	.rowSectionForm-field {
		margin: 22px 0 30px;
	}
	label { display: block; }
	select {
		margin-top: 10px;
		max-width: 146px;
		width: 100%;
		padding-right: 20px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	/*
	@see
	possible for custom arrow
	https://stackoverflow.com/questions/38870246/html-css-change-color-of-select-arrow
	color: #0B53B3;
	*/
	.beamsIconsWrap { display: inline-block; padding: 11px 0 0 10px; }
	.beamsIcons { display: flex; flex-direction: column; justify-content: space-between; height: 39px; }
	.fieldWrap { display: flex; }
	.beamsIcons .tooltipWrap, .beamsIcons .infoBeamsWrap { position: relative; margin: 0; }
	.customCheckbox + .tooltipWrap { margin-left: 10px;}
</style>
